import { Col, FormInstance, Row } from "antd";
import { CustomForm } from "../../Form/index.styled";
import { CheckableTagForm } from "./Form/CheckableTag";
import { RadioGroupForm } from "./Form/RadioGroup";

interface UserInfoServiceBatteryFormProps {
  form: FormInstance<any>;
  readonly?: boolean;
}

/**
 * 배터리 교체
 * @param param0
 * @returns
 */
export const UserInfoServiceBatteryForm: React.FC<
  UserInfoServiceBatteryFormProps
> = ({ form, readonly = false }) => {
  return (
    <>
      <CustomForm.Item>
        <RadioGroupForm
          name={[
            "repairShopOption",
            "options",
            "services",
            "battery",
            "isActivated",
          ]}
          rules={[
            {
              required: true,
            },
          ]}
          readonly={readonly}
        />
      </CustomForm.Item>
      <CustomForm.Item noStyle shouldUpdate>
        {({ getFieldValue }) =>
          getFieldValue([
            "repairShopOption",
            "options",
            "services",
            "battery",
            "isActivated",
          ]) && (
            <CustomForm.Item
              name={["repairShopOption", "options", "services", "battery"]}
              rules={[
                {
                  validator: (rule, value) => {
                    if (value && value?.isActivated === true) {
                      const checked = Object.entries(value).filter(
                        ([key, val]) => key !== "isActivated" && val === true
                      );

                      if (checked.length > 0) {
                        return Promise.resolve();
                      }
                    }
                    return Promise.reject(new Error("하나 이상 선택하세요."));
                  },
                },
              ]}
            >
              <Row gutter={[0, 8]}>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "battery",
                      "domesticVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "battery",
                        "domesticVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      국산차
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "battery",
                      "incomeVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "battery",
                        "incomeVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      수입차
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
              </Row>
            </CustomForm.Item>
          )
        }
      </CustomForm.Item>
    </>
  );
};
